<template>
  <div class="d-flex flex-wrap flex-column flex-sm-row justify-content-between">
    <div>
      <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
        Campaign
      </div>
      <div class="d-flex align-items-center w-100 cursor-pointer">
        <span class="mr-1 text-white">
          <VideoPlayIcon />
        </span>
        <span class="s-13 text-dak font-weight-600">
          <u>
            {{
              navigatorLang === "en-US"
                ? "Watch Video"
                : $t("people.watchVideo")
            }}
          </u>
        </span>
      </div>
    </div>
    <div class="d-flex flex-column flex-sm-row mt-2 my-1 link">
      <router-link class="mr-1" to="/tenant/campaign/campaigns">
        <el-button class="header-btn mr-3 w-100 secondary-button" round>
          View all Campaigns
        </el-button>
      </router-link>
      <router-link class="" to="/tenant/campaign/new-campaign">
        <el-button
          :color="primarycolor"
          class="header-btn w-100 mt-3 mt-sm-0"
          round
        >
          Create new Campaign
        </el-button></router-link
      >
    </div>
  </div>
  <div class="row mb-4 mt-5">
    <!-- Total Giving -->
    <div class="col-md-4 col-sm-6 col-12 mb-3">
      <div
        class="card card-summary bg-gray-200 border-gray-100 h-100 pb-1 px-3 pt-3"
      >
        <div
          class="card-icon d-flex justify-content-between mb-2 mt-1 align-items-center"
        >
          <span class="card-text">Total Campaigns</span>
        </div>
        <div class="card-content text-right mb-1 mt-5">
          <h3 class="card-title fw-500">78</h3>
        </div>
      </div>
    </div>

    <!-- Average Gift -->
    <div class="col-md-4 col-sm-6 col-12 mb-3">
      <div
        class="card card-summary border-gray-100 bg-gray-200 h-100 pb-1 px-3 pt-3"
      >
        <div
          class="card-icon d-flex justify-content-between mb-2 mt-1 align-items-center"
        >
          <span class="card-text">Total active Campaigns</span>
        </div>
        <div class="card-content text-right mb-1 mt-5">
          <h3 class="card-title fw-500">43</h3>
        </div>
      </div>
    </div>

    <!-- Most Project Funded -->
    <div class="col-md-4 col-sm-6 col-12 mb-3">
      <div
        class="card card-summary border-gray-100 bg-gray-200 h-100 pb-1 px-3 pt-3"
      >
        <div
          class="card-icon d-flex justify-content-between mb-2 mt-1 align-items-center"
        >
          <span class="card-text">Total Donation</span>
        </div>
        <div class="card-content text-right mb-1 mt-5">
          <div class="s-20 text-black">
            <span>NGN</span>
            <span class="fw-500"> 55,278,000</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <!-- Daily Trend Chart -->
          <div class="col-lg-6 col-12 mb-4">
            <div class="chart-container">
              <div class="fw-500 text-dak s-15">Campaigns by Value</div>
              <DonutChart
                dom-id="daily-trend-chart"
                :series-data="dailyTrendData"
                :colour="chartColors"
                :height="250"
                chart-type="donut"
                inner-size="75%"
                center-text="Total Value"
                center-value="72m"
                :show-legend="true"
                legend-position="right"
                :show-data-labels="false"
                @chart-click="handleChartClick"
                @legend-click="handleLegendClick"
                @chart-ready="onChartReady"
              />
            </div>
          </div>

          <!-- Payment Method Distribution Chart -->
          <div class="col-lg-6 col-12 mb-4">
            <div class="chart-container">
              <div class="fw-500 text-dak s-15">Campaigns by Participants</div>
              <DonutChart
                dom-id="payment-method-chart"
                :seriesData="paymentMethodData"
                :colour="chartColors"
                :height="250"
                chart-type="donut"
                inner-size="75%"
                center-text="Total Participants"
                center-value="254k"
                :show-legend="true"
                legend-position="right"
                :show-data-labels="false"
                @chart-click="handleChartClick"
                @legend-click="handleLegendClick"
                @chart-ready="onChartReady"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fuild mt-5">
    <TopPerformanceCampg />
  </div>
  <div class="container-fluid mt-5">
    <TableNoExport2
      :data="filteredCampaign"
      :headers="campaignHeadaer"
      @showfilter="handleFilter"
      @update:searchText="handleSearchTextUpdate"
      :checkMultipleItem="false"
      :filterItem="true"
      @checkedrow="handleSelectionChange"
    >
      <template v-slot:name="{ item }">
        <div class="c-pointer fw-400 s-14">{{ item.name }}</div>
      </template>

      <template v-slot:dateStarted="{ item }">
        <div class="c-pointer fw-400 s-14">
          {{ item.dateStarted }}
        </div>
      </template>
      <template v-slot:targetAmount="{ item }">
        <div class="c-pointer fw-400 s-14">
          N{{ item.targetAmount.toLocaleString() || "" }}
        </div>
      </template>
      <template v-slot:reached="{ item }">
        <div class="c-pointer fw-400 s-14" style="color: #1c6c04">
          N{{ item.reached.toLocaleString() || "" }}
        </div>
      </template>
      <template v-slot:toComplete="{ item }">
        <div class="c-pointer fw-400 s-14" style="color: #df6005">
          N{{ item.toComplete.toLocaleString() || "" }}
        </div>
      </template>

      <template v-slot:status="{ item }">
        <div class="c-pointer fw-400 s-14">
          {{ item.status }}
        </div>
      </template>
      <template v-slot:action="{ item }">
        <el-dropdown trigger="click">
          <el-icon><MoreFilled /></el-icon>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <div class="text-color" @click="deleteDonation(item.id, index)">
                  Delete
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </TableNoExport2>
  </div>
  
</template>
<script setup>
import { ref, computed, onMounted, inject } from "vue";
import DonutChart from "@/components/charts/DonationDonutChart.vue";
import VideoPlayIcon from "../../../components/svg/VideoPlayIcon.vue";
import TableNoExport2 from "../../../components/table/TableNoExport2.vue";
import TopPerformanceCampg from "./components/TopPerformanceCampg.vue";

const primarycolor = inject("primarycolor");
const navigatorLang = ref(navigator.language);
const searchText = ref("");
const showFilter = ref(false);
const handleFilter = (newValue) => {
  showFilter.value = newValue;
};
const campaignHeadaer = ref([
  { name: "CAMPAIGN NAME", value: "name" },
  { name: "DATE STARTED", value: "dateStarted" },
  { name: "TARGET", value: "targetAmount" },
  { name: "REACHED", value: "reached" },
  { name: "TO COMPLETE", value: "toComplete" },
  { name: "STATUS", value: "status" },
]);
const dailyTrendData = ref([
  { name: "Mobile Payments", y: 25 },
  { name: "Bank Transfer", y: 20 },
  { name: "Card Payments", y: 15 },
  { name: "Cash Donations", y: 15 },
  { name: "Online Banking", y: 15 },
  { name: "Others", y: 10 },
]);

const paymentMethodData = ref([
  { name: "Paystack", y: 30 },
  { name: "Flutterwave", y: 25 },
  { name: "Bank Transfer", y: 20 },
  { name: "Cash", y: 10 },
  { name: "Stripe", y: 10 },
  { name: "Others", y: 5 },
]);
const chartColors = ref([
  "#14B8A6", // teal
  "#3B82F6", // vivid blue
  "#6366F1", // cyan
  "#E697FF", // mint
  "#63ABFD", // sky blue
  "#CACACA", // emerald
]);
const campaigns = ref([
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "Active",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "InActive",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "Active",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "InActive",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "Active",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "InActive",
  },
]);
const filteredCampaign = computed(() => {
  if (!searchText.value) return campaigns.value;
  return campaigns.value.filter((d) =>
    Object.values(d).some((val) =>
      String(val).toLowerCase().includes(searchText.value.toLowerCase())
    )
  );
});
const handleChartClick = (data) => {
  console.log("Chart clicked:", data.point.name, data.point.y);
  // Handle chart segment click
};

const handleLegendClick = (data) => {
  console.log("Legend clicked:", data.point.name);
  // Handle legend item click
};

const onChartReady = (chart) => {
  console.log("Chart ready:", chart);
  // Handle chart ready event
};
</script>
<style scoped>
.card-summary {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}
.card {
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
}
.card-title {
  font-size: 25px !important;
  margin: 0;
  color: #000000;
}
.card-text {
  margin: 0;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #111111 !important;
}
.chart-container {
  height: 100%;
}
</style>
